// Functional: toggles the heart SVG between outline and filled via the
// --heart-fill CSS variable the Svg "heart" definition reads. Visual
// styling (size, color, hover) is consumer-owned — pass className /
// svgClassName to the component.
[data-is-favorite] .heart {
    --heart-fill: 100%;
}
